module.exports = __webpack_public_path__ + "9f18ba56c55ce690626c127108dd456c.pdf";